// Favorite script
  const customerId = window.theme.favSet.cid
  const pageType = window.theme.favSet.pageType
  const isProductPage = pageType === 'product'
  let favoritedVariantIDinDb = null

  async function setUserFavorite (data,svgIcon) {
    const FAV_SAVE_URL = "/apps/apibridge/integration/path/cm5gonun6000nvd4rx5bynb8h"
    svgIcon.parentNode.classList.add('svg-loading')
    try{
      await fetch(FAV_SAVE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
    } catch(e) {
      console.log("setUserFavorite ",e)
    }finally{
      svgIcon.parentNode.classList.remove('svg-loading')
    }
  }
  function handleLocalStorage(key,data){
    if(customerId) return

    const favorites = localStorage.getItem(key)
    if(favorites){
      const favoritesArray = JSON.parse(favorites);

      const dataKey = data.favoriteProduct.ProductTargetUniqueId
      let hasData = false
      for (let i=0; i < favoritesArray.length; i++) {
        if (favoritesArray[i].favoriteProduct.ProductTargetUniqueId == dataKey) {
            favoritesArray.splice(i, 1);
            hasData = true
        }
      }
      if(!hasData) {
        favoritesArray.push(data)
      }
      localStorage.setItem(key, JSON.stringify(favoritesArray));
    } else {
      const localData = [data]
      localStorage.setItem(key,JSON.stringify(localData))
    }
  }
  function handleSessionStorage(key,data){
    if(!customerId) return

    const favorites = sessionStorage.getItem(key)
    if(favorites){
      const favoritesArray = JSON.parse(favorites);

      const dataKey = data.favoriteProduct.ProductTargetUniqueId
      let hasData = false
      for (let i=0; i < favoritesArray.length; i++) {
        const dataId = favoritesArray[i].productTargetUniqueId || favoritesArray[i].ProductTargetUniqueId
        if (dataId == dataKey) {
          favoritesArray.splice(i, 1);
          hasData = true
        }
      }
      if(!hasData) {
        favoritesArray.push(data.favoriteProduct)
      }
      sessionStorage.setItem(key, JSON.stringify(favoritesArray));
    } else {
      sessionStorage.setItem(key, JSON.stringify([data.favoriteProduct]));
    }
  }
  function handleClickCartFavorite(e) {
    const favSvg = e.currentTarget.firstElementChild.firstElementChild.firstElementChild
    const isFavorited = favSvg.classList.contains('fill-black')

    if(isFavorited) return
    const productData = {
      productTitle: favSvg.dataset.favtitle,
      productUrl: favSvg.dataset.favhandle,
      imageUrl: favSvg.dataset.favimg,
      currentSalePrice: +favSvg.dataset.favprice / 100,
      currentListPrice: +favSvg.dataset.saleprice / 100,
      variantTitle: favSvg.dataset.favvariantname
    }
    const data = {
      favoriteProduct:{
        ProductTargetUniqueId : favSvg.dataset.productfavid,
        ProductVariantTargetUniqueId : favSvg.dataset.variantfavid,
        CustomerTargetUniqueId : customerId,
        Data: JSON.stringify(productData)
      }
    }
    if(customerId) {
      setUserFavorite(data,favSvg)
      handleSessionStorage('favoriteItems',data)
    } else {
      handleLocalStorage('favoriteItems',data)
    }
  }
  function handleClickFavorite (e) {
    const productData = {
      productTitle: e.currentTarget.dataset.favtitle,
      productUrl: e.currentTarget.dataset.favhandle,
      imageUrl: e.currentTarget.dataset.favimg,
      currentSalePrice: +e.currentTarget.dataset.favprice / 100,
      currentListPrice: +e.currentTarget.dataset.saleprice / 100,
      variantTitle: e.currentTarget.dataset.favvariantname
    }
    const data = {
      favoriteProduct:{
        ProductTargetUniqueId : e.currentTarget.dataset.productfavid,
        ProductVariantTargetUniqueId : e.currentTarget.dataset.variantfavid,
        CustomerTargetUniqueId : customerId,
        Data: JSON.stringify(productData)
      }
    }
    handleAddToWishlistGTMEvent(e.currentTarget.dataset);
    e.currentTarget.classList.toggle('fill-black')
    if(!customerId) {
      handleLocalStorage('favoriteItems',data)
      return
    }
    setUserFavorite(data,e.currentTarget.parentNode)
    handleSessionStorage('favoriteItems',data)
  }
  function getVariantParams() {
    const params = new URLSearchParams(window.location.search);
    return +params.get('variant') || null;
  }
  function handleClickPDPFavorite(e) {
    const isFavorited = favoritedVariantIDinDb === null ? false : true

    const productData = {
      productTitle: e.currentTarget.dataset.favtitle,
      productUrl: e.currentTarget.dataset.favhandle,
      imageUrl: e.currentTarget.dataset.favimg,
      currentSalePrice: +e.currentTarget.dataset.favprice / 100,
      currentListPrice: +e.currentTarget.dataset.saleprice / 100,
      variantTitle: e.currentTarget.dataset.favvariantname
    }
    const data = {
      favoriteProduct: {
        ProductTargetUniqueId : e.currentTarget.dataset.productfavid,
        ProductVariantTargetUniqueId : e.currentTarget.dataset.variantfavid,
        CustomerTargetUniqueId : customerId
      }
    }
    isFavorited
    ? handleDeleteFavorite(data, e.currentTarget)
    : handleAddFavorite(data,productData,e.currentTarget)
    handleAddToWishlistGTMEvent(e.currentTarget.dataset);
    e.currentTarget.classList.toggle('fill-black')
  }
  function handleAddFavorite(data,productData,svgIcon){
    const currentVariant = getVariantParams()
    const currentPrice = Number(document.querySelector('[data-product-price]').innerText.replace(/\D/g, ""))
    let variantStr = ""
    const currentVariantNames = document.querySelectorAll('[data-current-value]')
    currentVariantNames.forEach((item,i) => {
      variantStr += item.innerText;
      i === 0 ? variantStr += ' / ' : null;
    })

    productData.price = currentPrice
    productData.vname = variantStr
    data.favoriteProduct.ProductVariantTargetUniqueId = currentVariant
    data.favoriteProduct.Data = JSON.stringify(productData)

    favoritedVariantIDinDb = currentVariant
    if(!customerId) {
      const favorites = localStorage.getItem('favoriteItems')
      const arr = favorites ? JSON.parse(favorites) : []

      data.favoriteProduct.ProductTargetUniqueId = data.favoriteProduct.ProductTargetUniqueId
      arr.push(data)
      localStorage.setItem('favoriteItems',JSON.stringify(arr))
      return
    }
    // add to sessionStorage
    const sessionFavorites = sessionStorage.getItem('favoriteItems')
    const sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
    sessionArr.push(data.favoriteProduct)
    sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

    setUserFavorite(data,svgIcon)
  }
  function handleDeleteFavorite(data,svgIcon){
    data.favoriteProduct.ProductVariantTargetUniqueId = favoritedVariantIDinDb
    favoritedVariantIDinDb = null
    if(!customerId) {
      const favorites = localStorage.getItem('favoriteItems')
      let arr = favorites ? JSON.parse(favorites) : []
      arr = arr.filter(item => item.favoriteProduct.ProductTargetUniqueId != data.favoriteProduct.ProductTargetUniqueId)
      localStorage.setItem('favoriteItems',JSON.stringify(arr))
      return
    }
    // delete from session
    const sessionFavorites = sessionStorage.getItem('favoriteItems')
    let sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
    sessionArr = sessionArr.filter(item => {
      const itemId = item.ProductTargetUniqueId || item.productTargetUniqueId
      return itemId != data.favoriteProduct.ProductTargetUniqueId
    })
    sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

    setUserFavorite(data,svgIcon)
  }
  async function setLocalStorageToDb(response, localfavs) {
    const FAV_SAVE_URL = "/apps/apibridge/integration/path/cm5gonun6000nvd4rx5bynb8h"
    const parsed = JSON.parse(localfavs)
    const dbIdArray = response.map(item => item.productTargetUniqueId)
    
    const requests = parsed
      .filter(item => !dbIdArray.includes(+item.favoriteProduct.ProductTargetUniqueId))
      .map(item => {
        item.favoriteProduct.CustomerTargetUniqueId = customerId
        Number(item.favoriteProduct.productTargetUniqueId)
        Number(item.favoriteProduct.productVariantTargetUniqueId)
        
        return fetch(FAV_SAVE_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(item)
        })
      })

    await Promise.all(requests)
    
    localStorage.removeItem('favoriteItems')
    getUserFavorites()
  }
  function handleFillFavoriteIcons(data,allFavoriteIcons,isSession = false) {
    if (!data.length) {
      allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'))
      return;
    }

    let userFavoriteMap
    if(!customerId) {
      data = data.map(item => item.favoriteProduct)
      userFavoriteMap = new Map(data.map(item => [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]));
    } else if(isSession) {
      userFavoriteMap = new Map(data.map(item => {
        if(item['guid']) return [item.productTargetUniqueId, item.productVariantTargetUniqueId]
        return [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]
      }));
    } else {
      userFavoriteMap = new Map(data.map(item => [item.productTargetUniqueId, item.productVariantTargetUniqueId]));
    }
    requestAnimationFrame(() => {
      allFavoriteIcons.forEach(icon => {
        const id = Number(icon.dataset.productfavid);
        if (userFavoriteMap.has(id)) {
          const variantId = userFavoriteMap.get(id)
          if(isProductPage && icon.hasAttribute('data-productselector')) {
            favoritedVariantIDinDb = variantId;
          }
          icon.classList.add('fill-black');
          icon.dataset.variantfavid = variantId;
        }
        icon.parentNode.classList.remove('svg-loading')
      });
    });
  }
  function handleAddToWishlistGTMEvent(dataset) {
    dataLayer.push({ 
      event: "add_to_wishlist",
      ecommerce: {
        currency: "TRY",
        items: [
          {
            item_id: dataset.productfavid,
            item_name:  dataset.favtitle,
            discount: dataset.saleprice && dataset.saleprice > dataset.favprice ? ((dataset.saleprice - dataset.favprice) / dataset.saleprice * 100).toFixed(0) : 0,
            item_brand: dataset.favoriteItemBrand,
            item_category: dataset.favoriteItemCategory,
            item_category2: dataset.favoriteItemCategory2,
            item_category3: dataset.favoriteItemCategory3,
            item_variant: dataset.favvariantname,
            price: (Number(dataset.favprice) / 100).toFixed(2),
            item_sku: dataset.favoriteItemSku
          }
        ]
      }
    }); 
  }
  async function getUserFavorites() {
    const allFavoriteIcons = document.querySelectorAll('[data-favorite-item]');

    const localFavorites = localStorage.getItem('favoriteItems')
    if(!customerId && localFavorites && allFavoriteIcons) {
      handleFillFavoriteIcons(JSON.parse(localFavorites),allFavoriteIcons)
      return
    }
    if(!customerId && !localFavorites) return

    const sessionFavorites = sessionStorage.getItem('favoriteItems')
    if(sessionFavorites){
    const parsedSessionFavorites = JSON.parse(sessionFavorites)
      if(parsedSessionFavorites.length && allFavoriteIcons) {
        handleFillFavoriteIcons(parsedSessionFavorites,allFavoriteIcons,true)
        return
      }
    }

    const FAV_GET_URL = "/apps/apibridge/integration/path/cm5gopv1o000uvd4r6i37gldl"
    try {
      const res = await fetch(FAV_GET_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({customer : customerId})
      });
      const result = await res.json()
      const response = getJsonFromApiBridge(result);

      if(customerId && localFavorites){
        setLocalStorageToDb(response.data,localFavorites)
        return
      }
      sessionStorage.setItem('favoriteItems',JSON.stringify(response.data))
      handleFillFavoriteIcons(response.data,allFavoriteIcons)
    } catch(e) {
      console.error("getUserFavorites", e)
    }

  }
  window.addEventListener("DOMContentLoaded", getUserFavorites)

  // Insider stock_quantity: PDP'de secili varyant degistikce favori butonundaki
  // data-favorite-item-stock degerini guncel tut. Beden secilmediginde Liquid'den
  // gelen urun seviyesindeki ilk deger korunur.
  const pdpFavoriteIcons = document.querySelectorAll('[data-favorite-item][data-productselector]')
  if (pdpFavoriteIcons.length) {
    const productLevelStock = pdpFavoriteIcons[0].dataset.favoriteItemStock || '1'
    document.addEventListener('theme:variant:change', (e) => {
      const variant = e.detail && e.detail.variant
      const stock = variant ? (variant.available ? '1' : '0') : productLevelStock
      pdpFavoriteIcons.forEach(icon => { icon.dataset.favoriteItemStock = stock })
    })
  }